module.exports = __webpack_public_path__ + "img/business_time.e03c9ce3.svg";